module.exports = __webpack_public_path__ + "static/media/icon-adjuntando1.b4cf5499.svg";